import { connect } from 'react-redux';
import styled from 'styled-components';

import { Flex } from '@frontend/legacy-components';

import { getActiveFile } from './data/reducer';

const connector = connect((state) => ({
  file: getActiveFile(state),
}));

const StyledImg = styled.img`
  display: block;
  margin: auto;
  max-height: 100%;
`;

const ImgViewer = ({ file }) => (
  <Flex h="100%">
    <StyledImg data-fs-hide="true" src={file.url} alt={file.filename} />
  </Flex>
);

export default connector(ImgViewer);
